import { ContractorPaymentInfo1nscg9rquslpg as ContractorPaymentInfo } from './ContractorPaymentInfo.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance } from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { get_scrolling27q1yr4ng0cx8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { notificationBar4efejtg2792g as notificationBar } from '../../theming/banners.mjs';
import { body3i5t0n7zprpqb as body } from '../../theming/Titles.mjs';
import { get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow } from '../../components/nav/crowpay.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_awaitingApprovalMessagemcfmnhjri98l as get_awaitingApprovalMessage,
  renderFinishRegistrationbdw1wx3e9bul as renderFinishRegistration,
  renderAwaitingApprovalsh6ugtdyt2je as renderAwaitingApproval,
  render2bonfr4ls49sc as render,
  ContractorPage2yk275fy06uv3 as ContractorPage,
} from './IsContractorScreen.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ContractorBillingInfoClass;
function ContractorBillingInfo() {
  if (ContractorBillingInfoClass === VOID) {
    class $ extends ContractorPaymentInfo() {
      constructor() {
        super();
        this.yje_1 = new (Constant())(_Constant___init__impl__v45mub('Billing'));
        this.zje_1 = MemberRole_Manager_getInstance();
      }
      ucv() {
        return this.yje_1;
      }
      bhg() {
        return this.zje_1;
      }
      rhi(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        if (get_viewIsNarrow(view))
          view.jbb(notificationBar(view, AppColors_getInstance().ifz_1), body(view, 'Please view this information on a larger screen.'));
        else
          this.jjf(view);
        _this__u8e3s4.fbb(p, view);
        _this__u8e3s4.jbb(tmp, view);
      }
    }
    protoOf($).dhg = get_awaitingApprovalMessage;
    protoOf($).ehg = renderFinishRegistration;
    protoOf($).fhg = renderAwaitingApproval;
    protoOf($).ud6 = render;
    initMetadataForClass($, 'ContractorBillingInfo', ContractorBillingInfo, VOID, [ContractorPage(), ContractorPaymentInfo()], [0, 1]);
    ContractorBillingInfoClass = $;
  }
  return ContractorBillingInfoClass;
}
//region block: exports
export {
  ContractorBillingInfo as ContractorBillingInfos14ebalmoocx,
};
//endregion

//# sourceMappingURL=ContractorBillingInfo.mjs.map
